import { INSTA_ROOT } from '../instaConfig';
import axios from 'axios';

export const InstagramPost = (screenName) => {
	return axios.get(`${INSTA_ROOT}/${screenName}/?__a=1`)
		.then(response => response)
}